import { hideLoader, showLoader } from "../Store/Readux/Reducer/LoaderSlice";
import { setSideMenuData } from "../Store/Readux/Reducer/SideMenuSlice";
import ApiConstants from "../Utils/ApiConstant";
import fetchServices from "./FetchServices";

export const getSideMenuData = (roleId) => async (dispatch, getState) => {
  dispatch(showLoader());
  try {
    const URL = ApiConstants.sideMenuURL;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    if (response.status_code === 200) {
      dispatch(setSideMenuData(response.data));
    }
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};